/**
 * Grade de depoimentos: só o que está na tela baixa e reproduz.
 * Saiu da tela → pause e corta o download.
 */
(function () {
  const ROOT_SEL = '.video-testimonials[data-vt-layout="stories_grid"]';
  const VISIBLE = 0.6;

  function cardOf(video) {
    return video.closest('[data-vt-grid-card]');
  }

  function syncPoster(card, playing) {
    if (!card) return;
    card.classList.toggle('is-playing', playing);
    card.classList.toggle('is-cover-visible', !playing);
    const playBtn = card.querySelector('[data-play]');
    if (playBtn) playBtn.classList.toggle('is-hidden', playing);
  }

  function rememberSrc(video) {
    if (video.dataset.vtSrc) return;
    const source = video.querySelector('source');
    video.dataset.vtSrc =
      video.getAttribute('src') ||
      video.currentSrc ||
      (source && (source.getAttribute('src') || source.src)) ||
      '';
  }

  function detach(video) {
    if (!video) return;
    rememberSrc(video);
    video.pause();
    video.removeAttribute('src');
    video.querySelectorAll('source').forEach(function (source) {
      source.removeAttribute('src');
    });
    try {
      video.load();
    } catch (e) {
      /* ignore */
    }
    syncPoster(cardOf(video), false);
  }

  function attach(video) {
    rememberSrc(video);
    const url = video.dataset.vtSrc;
    if (!url) return false;
    if (video.getAttribute('src') !== url) {
      video.src = url;
    }
    video.preload = 'auto';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
    return true;
  }

  function start(video, muted) {
    const card = cardOf(video);
    if (!card || !attach(video)) return;
    if (muted) {
      video.muted = true;
      video.defaultMuted = true;
    }
    const done = video.play();
    const ok = function () {
      syncPoster(card, true);
    };
    if (done && done.then) done.then(ok).catch(function () {});
    else if (!video.paused) ok();
  }

  function initCard(card) {
    const video = card.querySelector('video');
    const playBtn = card.querySelector('[data-play]');
    const muteBtn = card.querySelector('[data-mute]');
    const media = card.querySelector('.video-testimonials__media');
    if (!video || !playBtn) {
      if (playBtn) playBtn.hidden = true;
      if (muteBtn) muteBtn.hidden = true;
      return;
    }

    rememberSrc(video);
    detach(video);
    card.classList.add('is-cover-visible');

    function toggle(event) {
      if (event.target.closest('[data-mute], a, .video-testimonials__product')) return;
      event.preventDefault();
      event.stopPropagation();
      if (video.paused || !video.getAttribute('src')) {
        card.dataset.vtUserPause = '';
        const unmuted = muteBtn && muteBtn.classList.contains('is-unmuted');
        start(video, !unmuted);
      } else {
        card.dataset.vtUserPause = '1';
        video.pause();
        syncPoster(card, false);
      }
    }

    playBtn.addEventListener('click', toggle);
    media?.addEventListener('click', toggle);

    video.addEventListener('playing', function () {
      syncPoster(card, true);
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const unmuted = muteBtn.classList.toggle('is-unmuted');
        video.muted = !unmuted;
        muteBtn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        muteBtn.setAttribute(
          'aria-label',
          unmuted ? muteBtn.dataset.labelMute : muteBtn.dataset.labelUnmute
        );
        if (video.paused || !video.getAttribute('src')) start(video, !unmuted);
      });
    }
  }

  function boot() {
    const cards = [...document.querySelectorAll(`${ROOT_SEL} [data-vt-grid-card]`)];
    cards.forEach(initCard);

    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const card = entry.target;
          const video = card.querySelector('video');
          if (!video) return;
          const visible = entry.isIntersecting && entry.intersectionRatio >= VISIBLE;
          if (visible) {
            if (card.dataset.vtUserPause === '1') return;
            const unmuted = card.querySelector('[data-mute]')?.classList.contains('is-unmuted');
            start(video, !unmuted);
          } else {
            detach(video);
            card.dataset.vtUserPause = '';
          }
        });
      },
      { threshold: [0, 0.25, VISIBLE, 1] }
    );

    cards.forEach(function (card) {
      if (card.querySelector('video')) io.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
